module.exports = __webpack_public_path__ + "img/acediamonds.e9bd05b5.png";